import PropTypes from 'prop-types';
import { Container, Text, Box } from 'theme-ui';
import ContentCallToAction from '../CallToAction';
import React from 'react';

const TextSection = React.memo(function TextSection({ subtitle, title, body, cta, forwardSx, columnNumber = 2 }) {
  return (
    <Container
      py={0}
      sx={{
        px: ['2.4rem', '23.4rem'],
        py: ['12.4rem'],
        display: ['grid'],
        gridTemplateColumns: ['100%', '1fr 16rem'],
        gridTemplateAreas: [
          `
            ${subtitle ? '"subtitle ."' : ''}
            'title .'
            ${body ? '"body body"' : ''}
          `,
          `
            ${subtitle ? '"subtitle ."' : ''}
            ${cta ? '"title cta"' : '"title ."'}
            ${body ? '"body body"' : ''}
          `,
        ],
        ...forwardSx,
      }}
    >
      {subtitle ? (
        <Text as="p" variant="h5" sx={{ gridArea: 'subtitle', mb: '2.7rem' }}>
          {subtitle}
        </Text>
      ) : null}

      <Text as="h2" variant="h4" sx={{ width: '100%', fontSize: ['28px', '32px'], lineHeight: '24px' }}>
        {title}
      </Text>

      {cta ? (
        <Box
          sx={{
            gridArea: 'cta',
            justifySelf: 'flex-end',
            display: ['none', 'block'],
            p: { m: 0 },
            a: {
              variant: ['buttons.primary'],
              '--background-color': 'white',
              '--color': 'black',
              minWidth: ['15rem', '15rem'],
              width: ['min-content', 'min-content'],
              height: '48px',
              fontSize: '1.2rem',
            },
          }}
        >
          <ContentCallToAction content={cta} />
        </Box>
      ) : null}

      {body && body.childMarkdownRemark ? (
        <div
          dangerouslySetInnerHTML={{ __html: body.childMarkdownRemark.html }}
          sx={{
            gridArea: 'body',
            columnCount: [null, columnNumber],
            columnGap: [null, '2.4rem'],
            fontWeight: 'medium',

            p: { mt: 0, lineHeight: ['26.1px'] },
            pb: ['11.5rem', null, '20rem'],
            ol: {
              pl: ['.5rem', '1.6rem'],
              mb: 0,
              li: {
                mb: '1rem',
                fontSize: ['1rem', '1.2rem'],
                lineHeight: ['1.4rem', '2.1rem'],
              },
            },
          }}
        />
      ) : null}
    </Container>
  );
});

TextSection.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  body: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string.isRequired,
    }).isRequired,
  }),
  cta: PropTypes.shape({}),
};

export default TextSection;
